import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { ErrorMessage, Field } from "formik";

interface TaskDateTimeFieldsProps {
  errors: any;
  touched: any;
  visibleRecurring: boolean;
}

export const TaskDateTimeFields: React.FC<TaskDateTimeFieldsProps> = ({
  errors,
  touched,
  visibleRecurring,
}) => {
  if (visibleRecurring) return null;

  return (
    <>
      <Form.Group as={Row} className="mb-3" controlId="taskCreationDate">
        <Form.Label column sm={3}>
          Start Time <span style={{ color: 'red' }}>*</span>
        </Form.Label>
        <Col sm={4}>
          <Field name="creationDate" type="date" className={"form-control" + (errors.creationDate && touched.creationDate ? " is-invalid" : "")} />
          <ErrorMessage name="creationDate" component="div" className="invalid-feedback" />
        </Col>
        <Col sm={4}>
          <Field name="startTime" type="time" className={"form-control" + (errors.startTime && touched.startTime ? " is-invalid" : "")} />
          <ErrorMessage name="startTime" component="div" className="invalid-feedback" />
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3" controlId="taskDueDate">
        <Form.Label column sm={3}>
          Due/End Time <span style={{ color: 'red' }}>*</span>
        </Form.Label>
        <Col sm={4}>
          <Field name="dueDate" type="date" className={"form-control" + (errors.dueDate && touched.dueDate ? " is-invalid" : "")} />
          <ErrorMessage name="dueDate" component="div" className="invalid-feedback" />
        </Col>
        <Col sm={4}>
          <Field name="endTime" type="time" className={"form-control" + (errors.endTime && touched.endTime ? " is-invalid" : "")} />
          <ErrorMessage name="endTime" component="div" className="invalid-feedback" />
        </Col>
      </Form.Group>
    </>
  );
};
